// Explicit enum because we might save data to localStorage
export enum TaskGroupsView {
  SINGLE_COLUMN = 0,
  MULTI_COLUMN = 1, // NOTE: this is not the teams->space->board, but an alias to column view
}

// Explicit enum because we might save data to localStorage
export enum TaskGroupsFilter {
  TIME = 0,
  CATEGORY = 1,
  LABEL = 2,
}

export enum TaskGroupsType {
  CATEGORY,
  BOARD,
  LABEL,
  /**
   * All tasks, not included grocery list tasks
   */
  ALL_TASKS,
  MYDAY,
  NEXT_SEVEN_DAYS,
  CUSTOM_VIEW,
  GROCERY_BOARD,
}
